export const initialState = {
  theme: 'dark',
  menuOpen: false,
  serviceWorkerStatus: 'unregistered',
  networkStatus: 'online',
  pwaStatus: 'uninstalled',
};

export function reducer(state, action) {
  switch (action.type) {
    case 'setTheme':
      return { ...state, theme: action.value };
    case 'toggleTheme':
      return { ...state, theme: state.theme === 'dark' ? 'light' : 'dark' };
    case 'toggleMenu':
      return { ...state, menuOpen: !state.menuOpen };
    case 'setServiceWorkerStatus':
      return { ...state, serviceWorkerStatus: action.value };
    case 'setNetworkStatus':
      return { ...state, networkStatus: action.value };
    case 'setPWAStatus':
      return { ...state, pwaStatus: action.value };
    default:
      throw new Error(`Unknown action: ${action.type}`);
  }
}
